<template>
  <div class="modal fade" id="amazon-fees-modal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="close" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-info-circle mr-5"></i>Info</h4>
        </div>
        <div class="modal-body">
          <p>
            <strong>{{'amazon_fees_info' | translate}}</strong> {{'amazon_fees_info_body' | translate}}
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-danger btn-app" data-dismiss="modal"><span class="fa fa-times "></span>{{'close' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AmazonFeesModal.vue'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/Modals/AmazonFeesModal.vue